import React from 'react'
import { WrapperExternalAuthOptions } from './ExternalAuthOptions.styles'
import ButtonExternalAuthOption from 'components/button-external-auth-option'
import {
  useExternalLogin,
  LOGO_GOOGLE,
  LOGO_MICROSOFT
} from 'utils/hooks/use-external-login'

const ExternalAuthOptions = () => {
  const { loginWithGoogle, loginWithMicrosoft } = useExternalLogin()

  return (
    <WrapperExternalAuthOptions>
      <ButtonExternalAuthOption
        onClick={loginWithGoogle}
        text="Google"
        icon={LOGO_GOOGLE}
      />
      <ButtonExternalAuthOption
        onClick={loginWithMicrosoft}
        text="Microsoft"
        icon={LOGO_MICROSOFT}
      />
    </WrapperExternalAuthOptions>
  )
}

export default ExternalAuthOptions
